module.exports = __webpack_public_path__ + "img/frame-4.d922c1c4.svg";